import { useState, useEffect } from "react";

// Hook optimizado con debounce para evitar re-renders excesivos
export const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );

  useEffect(() => {
    // Debounce para reducir re-renders durante el resize
    let timeoutId = null;

    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setWindowWidth(window.innerWidth);
      }, 100); // Espera 100ms después de que el usuario deje de hacer resize
    };

    window.addEventListener("resize", handleResize);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return windowWidth;
};

// Hook alternativo con breakpoints específicos (más eficiente)
export const useResponsiveBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState(() => {
    if (typeof window === "undefined") return "desktop";
    const width = window.innerWidth;
    if (width <= 480) return "mobile-small";
    if (width <= 768) return "mobile";
    if (width <= 992) return "tablet";
    if (width <= 1200) return "laptop";
    if (width <= 1500) return "desktop";
    return "desktop-large";
  });

  useEffect(() => {
    let timeoutId = null;

    const getBreakpoint = (width) => {
      if (width <= 480) return "mobile-small";
      if (width <= 768) return "mobile";
      if (width <= 992) return "tablet";
      if (width <= 1200) return "laptop";
      if (width <= 1500) return "desktop";
      return "desktop-large";
    };

    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        const newBreakpoint = getBreakpoint(window.innerWidth);
        setBreakpoint((prev) => prev !== newBreakpoint ? newBreakpoint : prev);
      }, 100);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return breakpoint;
};
